import {
  Flex,
  Dialog,
  Button,
  BufferIcon,
  ArrowLeftRightIcon,
  XIcon,
  ChannelIcon,
} from '@buffer-mono/popcorn'

import { BackButton } from '../../../services/_shared/components/BackButton/BackButton'

import styles from './Header.module.css'

import type { JSX } from 'react'

export function Header({ onClose }: { onClose: () => void }): JSX.Element {
  return (
    <Dialog.Header className={styles.wrapper}>
      <Flex direction="row" justify="between" align="center">
        <BackButton variant="tertiary" size="small" />
        <Flex gap="sm" align="center">
          <BufferIcon />
          <ArrowLeftRightIcon color="subtle" />
          <ChannelIcon type="bluesky" color="branded" />
        </Flex>
        <Button
          variant="tertiary"
          size="small"
          className={styles.button}
          onClick={onClose}
        >
          <XIcon />
        </Button>
      </Flex>
    </Dialog.Header>
  )
}
